import { Helmet } from "react-helmet-async";
import AdminShell from "@/web/components/admin/admin-shell";
import { Card, CardContent, CardHeader, CardTitle } from "@/web/components/ui/card";

const CARDS = [
  { title: "Orders today", value: "—" },
  { title: "Revenue this week", value: "—" },
  { title: "Low stock", value: "—" },
  { title: "New customers", value: "—" },
];

export default function AdminIndex() {
  return (
    <>
      <Helmet><title>Admin | Cool Wave</title></Helmet>
      <AdminShell>
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {CARDS.map((c) => (
            <Card key={c.title}>
              <CardHeader>
                <CardTitle className="text-sm font-medium text-body">{c.title}</CardTitle>
              </CardHeader>
              <CardContent className="text-3xl font-bold text-ink">{c.value}</CardContent>
            </Card>
          ))}
        </div>
        <p className="mt-6 text-sm text-body">Admin dashboard is auth-gated to <code>role === "admin"</code> when authentication is activated.</p>
      </AdminShell>
    </>
  );
}
